module.exports = __webpack_public_path__ + "media/images/icon-medal-b9cd0b689ed3431da3ce76f2ed201956.svg";